import shortid from 'shortid'

import { messagesAtionsTypes } from '../actions/messages'

const initialState = []

function filterMessageText(message) {
  return message
    .replace('Network error:', '')
    .replace('GraphQL error:', '')
    .trim()
}

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case messagesAtionsTypes.ADD_MESSAGE: {
      const message = {
        ...payload.message,
        id: shortid.generate(),
        text: filterMessageText(payload.message.text),
      }
      return [...state, message]
    }
    case messagesAtionsTypes.CLEAR_ADD_MESSAGE: {
      const message = {
        ...payload.message,
        id: shortid.generate(),
        text: filterMessageText(payload.message.text),
      }
      return [message]
    }
    case messagesAtionsTypes.REMOVE_MESSAGE: {
      const idx = state.findIndex((m) => m.id === payload.id)
      const messages = Object.assign([], state.messages)
      messages.splice(idx, 1)
      return messages
    }
    case messagesAtionsTypes.REMOVE_MESSAGE: {
      return []
    }
    default:
      return state
  }
}

export default { messages: reducer }
